import { Box } from '@mui/material'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { audioTrackZ, StylesClassNames } from '../styles'

type GridDataProps = {
  /**
   * Width of each individual bar in the visualization. Defaults to `2`
   */
  barWidth: number
  height: number
}

type GridProps = GridDataProps & {
  background?: boolean
}

function Grid({ barWidth, height, background = false }: GridProps) {
  return (
    <>
      <Box
        borderRadius={2}
        minWidth={barWidth}
        height={height - 8}
        overflow="hidden"
        bgcolor={background ? 'text.secondary' : 'text.primary'}
      />
      <Box
        borderRadius={2}
        minWidth={barWidth}
        overflow="hidden"
        height={height}
        bgcolor={background ? 'text.secondary' : 'text.primary'}
      />
      <Box
        overflow="hidden"
        borderRadius={2}
        minWidth={barWidth}
        height={height - 8}
        bgcolor={background ? 'text.secondary' : 'text.primary'}
      />
    </>
  )
}

export type AudioVisualizerDataProps = {
  maxTrackWidth: number
} & GridDataProps

type AudioVisualizerProps = {
  csx?: CustomStyles<StylesClassNames>
  hidden?: boolean
  currentTime: number
  duration: number
} & AudioVisualizerDataProps

export function AudioVisualizer({
  csx,
  maxTrackWidth,
  hidden = false,
  barWidth,
  height,
  currentTime,
  duration,
}: AudioVisualizerProps) {
  const styles = getStyles(defaultStyles, csx)

  if (hidden) {
    return null
  }

  return (
    <Box
      {...styles('visualizer', {
        height,
      })}
    >
      <Box
        {...styles('visualizerBg', {
          width: '100%',
          maxWidth: maxTrackWidth,
          zIndex: audioTrackZ.visualizerTrack,
          gap: `${barWidth}px`,
        })}
      >
        {Array.from({ length: maxTrackWidth / barWidth / 3 }, (_, index) => (
          <Grid
            key={`primary-vg-bar-${index}`}
            background
            height={height}
            barWidth={barWidth}
          />
        ))}
      </Box>
      <Box
        {...styles('visualizerBg', {
          width: `${(currentTime / duration) * 100}%`,
          zIndex: audioTrackZ.visualizerTracker,
          gap: `${barWidth}px`,
        })}
      >
        {Array.from({ length: maxTrackWidth / barWidth / 3 }, (_, index) => (
          <Grid
            key={`secondary-vg-bar-${index}`}
            height={height}
            barWidth={barWidth}
          />
        ))}
      </Box>
    </Box>
  )
}
